import { Checkbox, Chip } from "@mui/material";

export const ColoredCheckbox = ({ checked, onChange, color, disabled = false }) => {
  return (
    <Checkbox
      checked={checked}
      onChange={onChange}
      disabled={disabled}
      sx={{
        color: color || '#13a7b9',
        '&.Mui-checked': {
          color: color || '#13a7b9',
        },
      }}
    />
  );
};


export const getColorForRole = (role) => {
  const roleColors = {
    'Administrator': '#7986CB', 
    'Doctor': '#4FC3F7',        
    'Nurse': '#81C784',         
    'Receptionist': '#FFB74D',  
    'Laboratory Staff': '#BA68C8', 
    'Pharmacy Staff': '#4DB6AC', 
    'IT Support': '#F06292',
    'admin': '#7986CB',    
  };
  
  return roleColors[role] || '#90A4AE'; 
};


export const RoleChip = ({ roleName }) => {
  return (
    <Chip
      label={roleName}
      sx={{
        backgroundColor: 'transparent',
        color: getColorForRole(roleName), 
        fontWeight: 'bold',
        minWidth: '120px',
        justifyContent: 'center',
        border: '2px solid', 
        borderColor: getColorForRole(roleName), 
      }}
    />
  );
};

// Component for module chips
export const ModuleChip = ({ moduleName }) => {
  const getColorForModule = (module) => {
    const moduleColors = {
      'Patient': '#26A69A',     
      'Doctor': '#42A5F5',        
      'Role Permissions': '#7E57C2',
      'RolePerminsions': '#7E57C2', 
      'Floor': '#66BB6A',
      'floor': '#66BB6A',        
      'Block': '#AB47BC',         
      'Ward': '#5C6BC0',       
      'History': '#29B6F6', 
      'DoctorProfile': '#26C6DA',  
      'StaffProfile': '#FF7043', 
      'SecurityProfile': '#66BB6A',
      'TransferPatient': '#EC407A',
      'TransferProfile': '#EC407A', 
    };
    
    return moduleColors[module] || '#78909C'; 
  };
  
  return (
    <Chip
      label={moduleName}
      sx={{
        backgroundColor: 'transparent',
        color: getColorForModule(moduleName), 
        minWidth: '120px',
        justifyContent: 'center',
        border: '2px solid', 
        borderColor: getColorForModule(moduleName), 
      }}
    />
  );
};